import e118Data from "./e118-iin-data.json";

/** Tuple stored in the vendored ITU-T E.118 IIN list (see sync-e118-iin-data.mjs). */
type E118IssuerTuple = [number, string, number, string, string, string[]];

export interface E118IssuerMatch {
  iin: number;
  issuerIdentifierNumber: string;
  countryCode: number;
  countryName: string;
  companyName: string;
  companyURLs?: string[];
}

const iinRegEx = new RegExp(e118Data.iinRegEx);
const e118IINList = e118Data.e118IINList as unknown as Record<string, E118IssuerTuple>;

/** ITU-T E.118 issuer lookup with variable-length IIN prefix matching. */
export function identifyIssuerFromIccid(iccid: string): E118IssuerMatch | null {
  const normalized = String(iccid ?? "").trim().toLowerCase();
  if (normalized === "") {
    return null;
  }
  const iinMatch = iinRegEx.exec(normalized);
  if (!iinMatch) {
    return null;
  }
  const issuer = e118IINList[iinMatch[1]!];
  if (!issuer) {
    return null;
  }
  return {
    iin: issuer[0],
    issuerIdentifierNumber: issuer[1],
    countryCode: issuer[2],
    countryName: issuer[3],
    companyName: issuer[4],
    ...(issuer[5].length > 0 ? { companyURLs: issuer[5] } : {}),
  };
}
